<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :actions="actions"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :beforeSetupGrid="beforeSetupGrid"
            :selectionEnabled="true"
            ref="grid"
        ></dx-grid>

        <v-dialog persistent v-model="addNewBusDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0">New Bus</v-card-title>

                <v-text-field
                    class="mx-2 mb-2"
                    v-model="newBus.busNumber"
                    label="Bus Number"
                    ref="newBusNumber"
                    :rules="[rules.required]"
                ></v-text-field>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="addNewBusDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveNewBus()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--         <v-dialog persistent v-model="updateBusDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-2 pt-2"
                    >Update Bus - {{ rowClicked.busNumber }}</v-card-title
                >

                <v-layout row>
                    <v-layout column xs6 class="pr-2" style="min-width: 40%">
                        <v-text-field
                            class="mx-2"
                            v-model="rowClicked.phoneNumber"
                            label="Phone Number"
                            ref="phoneNumber"
                            :rules="[rules.phoneNumber, rules.required]"
                        ></v-text-field>
                        <v-layout class="pa-0">
                            <v-text-field
                                class="mx-2 pt-2"
                                v-model="rowClicked.name"
                                label="Name"
                                ref="name"
                                :rules="[rules.required]"
                            ></v-text-field>
                        </v-layout>
                        <v-layout class="pa-0">
                            <v-text-field
                                class="mx-2 pt-2"
                                v-model="rowClicked.nameH"
                                label="Hebrew Name"
                                ref="nameH"
                                :rules="[rules.required]"
                            ></v-text-field>
                        </v-layout>
                        <v-text-field
                            class="mx-2 pt-2"
                            v-model="rowClicked.note"
                            label="Note"
                            ref="note"
                        ></v-text-field>
                        <v-select
                            class="mx-2"
                            v-model="rowClicked.branch"
                            label="Branch"
                            ref="branch"
                            multiple
                            :items="branchList"
                        ></v-select>
                    </v-layout>
                </v-layout>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="updateBusDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveBus()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog> -->

        <v-dialog persistent v-model="deleteDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Delete Buses</v-card-title
                >
                <div class="font-weight-regular">
                    The {{ selected.length }} selected buses will be deleted
                </div>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="deleteDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteBuses"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import moment from "moment";
import AWS from "aws-sdk";

export default {
    data: () => ({
        title: "Buses",

        actions: [],

        updateBusDialog: false,
        addNewBusDialog: false,

        rowClicked: {
            id: "",
            busNumber: "",
        },

        newBus: {
            id: "",
            busNumber: "",
        },

        processing: false,
        deleteDialog: false,
        deleting: false,
        selected: [],
        files: [],
        url: "",

        rules: {
            required: (value) => !!value || "Required.",
            pinNumber: (v) => {
                return (
                    !v ||
                    ([5].includes(v.replace(/-/g, "").length) &&
                        /^\d+$/.test(v.replace(/-/g, ""))) ||
                    "Invalid Pin Number, Must be 5 digits"
                );
            },
            phoneNumber: (v) => {
                return (
                    !v ||
                    ([10, 11].includes(v.replace(/-/g, "").length) &&
                        /^\d+$/.test(v.replace(/-/g, ""))) ||
                    "Invalid Phone Number"
                );
            },
        },

        columns: [
            {
                label: "ID",
                field: "id",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus Number",
                field: "busNumber",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Drivers",
                field: "drivers",
                visible: true,
                type: "number",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    mounted() {},
    beforeDestroy() {},
    async created() {},
    methods: {
        async beforeSetupGrid() {
            this.actions.push({
                text: "Delete Buses",
                action: this.openDeleteBusesDialog,
                showOnSelection: true,
            });

            this.actions.push({
                text: "Add Bus",
                action: this.addBus,
            });

            this.url = "bus";
        },
        addBus() {
            this.addBusDialog = true;
        },
        async saveNewBus() {
            if (!this.$refs.newBusNumber.validate(true)) return;

            try {
                this.processing = true;

                await this.$http.post("api/bus/save", {
                    busNumber: this.newBus.busNumber,
                });

                this.processing = false;
                this.addNewBusDialog = false;

                this.newBus.id = "";
                this.newBus.busNumber = "";

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async onRowClicked(row) {
            this.rowClicked = JSON.parse(JSON.stringify(row));

            this.updateBusDialog = true;
        },
        addBus() {
            this.addNewBusDialog = true;
        },
        openDeleteBusesDialog() {
            this.selected = this.$refs.grid.getSelectedRowsData();

            this.deleteDialog = true;
        },
        async deleteBuses() {
            try {
                const ids = this.selected.map((s) => s.id);

                this.processing = true;

                await this.$http.post("api/bus/delete", ids);

                this.processing = false;
                this.deleteDialog = false;

                this.$notify({
                    group: "notification",
                    text: ids.length + " Buses Deleted",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async saveBus() {
            if (!this.$refs.busNumber.validate(true)) return;

            try {
                this.processing = true;

                await this.$http.post("api/bus/save", data);

                this.updateBusDialog = false;
                this.processing = false;

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.gray-fg {
    color: #999;
}
</style>
